module.exports = __webpack_public_path__ + "static/media/bfile-housemaker.d491650c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-housemaker.svg
// module id = 972
// module chunks = 0